<template>
  <div>
    <!-- Passando dialoglogin como prop para HeaderHome -->
    <HeaderHome :dialoglogin.sync="dialoglogin"></HeaderHome>
    <vue-headful
      title="Consultor Digital | Editora do Brasil"
      description="Veja todo o Catálogo Digital da Editora do Brasil"
    />

    <div class="conteudo-full box-img-background">
      <v-container>
          <div class="d-flex flex-row">            
              <v-row class="conteudo">
                  <v-col cols="6" class="col-md-6 box-txt-home"> 
                      <h2>
                          Consultor Digital
                      </h2>
                      <h3>Descubra o melhor da Editora do Brasil!</h3>
                      <p>
                        Navegue pelos nossos livros, explore cada detalhe das obras e aproveite uma experiência digital completa, prática e interativa
                        para acessar todo o conteúdo da Editora do Brasil. 
                      </p>
                      <v-btn class="bot-1 theme--light" @click="abrirModalLogin">Acessar</v-btn>
                      
                  </v-col>
                  <v-col cols="6" class="col-md-6 box-img-home">                               
                  </v-col>
              </v-row>            
          </div>
      </v-container>

      <v-img src="@/assets/img_home01.jpg" class=" box-img-homeh box-mobile" />
    </div>
    <!-- Passando dialoglogin como prop para o componente Login -->
    <Login :dialoglogin.sync="dialoglogin"></Login>
    <!-- MODAL LGPD -->
    <div class="bg" id="bg">
        <div class="cookies">
        <p>Utilizamos cookies para oferecer melhor experiência, melhorar o desempenho, analisar como você interage em nosso site e personalizar o conteúdo. Confira nossas <a href="http://politicadecookies.editoradobrasil.com.br" target="_blank" rel="noopener noreferrer">Políticas de Cookies</a> e <a href="https://conteudos.editoradobrasil.com.br/politicas/politicas-de-cookies-e-privacidade.pdf" target="_blank" rel="noopener noreferrer">Privacidade</a>.<button class="btn-cookies" id="btn-cookies">Estou de acordo</button></p>
        <!-- <a href="#" class="close" data-dismiss="modal"><i class="material-icons md-24">close</i></a> -->
        </div>
    </div>
    <!-- MENSAGEM DE MANUTENÇÃO -->
    <div class="fundo-msg" id="fundo-msg">
        <div class="box-msg">
            <img src="../plugins/msg-manutencao/img/logocolor.svg" class="logo img-fluid" />
            <h4>Não é possível acessar no momento.<br>Sistema em manutenção temporária.</h4>
        </div>
    </div>
    <!-- Modal de manutenção postgre-->
    <ManutencaoModal
      :maintenanceStart="MAINTENANCE_START"
      :announceUntil="ANNOUNCE_UNTIL"
      :storageKey="STORAGE_KEY"
      @dismissed="onMaintenanceDismissed"
    />
  </div>
</template>

<script>
import Login from './Login.vue'
//import EsqueciSenha from './EsqueciSenha.vue'
import HeaderHome from "./HeaderHome"
import { http } from "../services/APIservice";
import '../plugins/modal-lgpd/css/style.css'
import '../plugins/msg-manutencao/css/style.css'
import ManutencaoModal from '@/components/ManutencaoModal.vue';
//import $ from 'jquery';

//$('button.bot-exit').fadeIn();

export default {
  name: "Home",
  components: {
    Login,
    //EsqueciSenha,
    HeaderHome,
    ManutencaoModal 
  },
  data (){
    return {      
      component:Login,
      dialoglogin: false,
      MAINTENANCE_START: '2025-10-14T00:00:00-03:00',
      ANNOUNCE_UNTIL:    '2025-10-27T23:59:59-03:00',
      STORAGE_KEY:       'maintenancePopupDismissed_20251020'
    }
  },
  methods: {
    abrirModalLogin() {
      this.dialoglogin = true;
    },
    getMaintenancePage() {
      return http.post("user/GetMaintenancePage")
          .then(res => {         

                if(res.data.maintenancePage){
                  document.getElementById('fundo-msg').style.display = 'block';
                }else{
                  document.getElementById('fundo-msg').style.display = 'none';
                }              
          })
          // .catch(error => {
          //     console.log(error.res.status);
          // });
    },
    onMaintenanceDismissed() {
      // hook opcional (telemetria, toast, etc.)
      // console.log('modal fechado');
    }
  },
  mounted() {
    (function () {
      "use strict";


      
      var cookieName = 'cookieConsentCD'; // nome do cookie
      var cookieLifetime = 365; // cookie expira em...
      
      /**
      * Set cookie
      * @param cname - cookie name
      * @param cvalue - cookie value
      * @param exdays - expiry in days
      */
      var _setCookie = function (cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
          var expires = "expires=" + d.toUTCString();
          document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      };
      
      /**
      * Get cookie
      * @param cname - cookie name
      * @returns string
      */
      var _getCookie = function (cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                  c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
              }
          }
          return "";
      };
      
      /**
      * Verifica se já foi aceito
      */
      var _shouldShowPopup = function () {
          if (_getCookie(cookieName)) {
              return false;
          } else {
              return true;
          }
      };
      
      // Mostra o cookie popup on caso nao tenha sido aceitado
      if (_shouldShowPopup()) {
          console.log('show lgpd');
          document.getElementById('bg').style.display = 'block';
      }
      
      // Some com o modal cookie
      document.getElementById('btn-cookies').addEventListener("mousedown", function(){
          _setCookie(cookieName, 1, cookieLifetime);
          document.querySelector('.bg').style.display = 'none';
      });
      
  })();

  if (this.shouldShow()) this.showMaintenance = true;

  this.getMaintenancePage();
  }
};
</script>

<style lang="scss">
@use "../css/style.scss";
</style>
